import { RECOMMENDATION_VIEW } from '~~/constants/googleTagManager';
import type { TagProductBox } from '~~/types/integrations/tagManager/TagProductBox';
import type { EcommerceSimilarProductsView } from '~~/types/integrations/tagManager/TagViewProduct';
import type { RecommendationTypeName } from '~~/types/localization/localizationHelperTypes';
import { RECOMMENDATION_TYPE_NAME, RECOMMENDATION_DESCRIPTION } from '~~/types/localization/localizationHelperTypes';

export const buildRecommendationsShownTags = ({
  recommendationType,
  productTags,
}: {
  recommendationType?: RecommendationTypeName;
  productTags: TagProductBox[];
}) => {

  const currentEvent = recommendationType || RECOMMENDATION_TYPE_NAME.SIMILAR_PRODUCTS;

  return {
    event: RECOMMENDATION_VIEW[currentEvent] || null,
    eventInfo: {
      detail: RECOMMENDATION_DESCRIPTION[currentEvent],
    },
    ecommerce: {
      items: productTags,
    } as EcommerceSimilarProductsView,
  };

};
